import { c as _c } from "react/compiler-runtime";
import type { ProjectDetail } from "@/types/projects";
import { ProjectGrid } from "@/ui/project-cards/card-grid";
export function ProjectCards(t0) {
  const $ = _c(3);
  const {
    projects
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="theme-transition container my-6 flex items-center gap-2 text-2xl text-current lg:px-8"><a className="appearance-auto" id="projects">Featured Projects</a></h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== projects) {
    t2 = <div className="mx-auto max-w-screen px-0 pt-16 pb-8 lg:pt-24 lg:pb-12">{t1}<ProjectGrid projects={projects} /></div>;
    $[1] = projects;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
/**
 *           <GentleText
            content="Featured Projects"
            textClassName="appearance-auto"
            maxWidth="600px"
            as="a"
            textId="projects"
            animateOnlyInView={true}
            inViewThreshold={0.8}
            animationOptions={{ repeat: 0 }}
          />
 */